/* eslint-disable array-bracket-newline */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ILeaderboard } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import LeaderboardTable from './Table';
import { IStore } from '../../../reducers';
import { CexAPI } from '../../../store/createStore';
import { actionSetLeaderboard } from '../../../actions/competition';
import useDevice from '../../MainPage/useMobileDetect';
import LeaderboardTableMobile from './Table/TableMobile';

import './styles.scss';

interface ILeaderboardProps {
  data: ILeaderboard[];
}

const Leaderboard = ({ data }: ILeaderboardProps) => {
  const [search, setSearch] = useState('');
  const [leadeboard, setLeadarboard] = useState(data);

  const refresh = useSelector((state: IStore) => state.competition.refresh);

  const dispatch = useDispatch();
  const { exchange } = useParams();
  const { isMobile } = useDevice();

  useEffect(() => {
    const controller = new AbortController();

    if (refresh) {
      CexAPI.fetchLeaderboard(exchange || 'binance', {
        signal: controller.signal,
      }).then((resp) => setLeadarboard(resp || []));
    }

    return () => {
      controller.abort();
    };
  }, [refresh, exchange]);

  useEffect(() => {
    dispatch(actionSetLeaderboard(leadeboard));
  }, [dispatch, leadeboard]);

  return (
    <div className='leaderboard'>
      <div className='leaderboard__header'>
        <Text size={14} className='text--grey-200'>
          Competition Leaderboard
        </Text>

        {!isMobile && (
          <div className='leaderboard__header__find'>
            <div className='icon-search' />
            <input
              className='field text text--12 text--grey-600 text--weight-500'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder='Search in Leaderboard...'
            />
          </div>
        )}
      </div>
      {isMobile ? (
        <LeaderboardTableMobile tableData={leadeboard} />
      ) : (
        <LeaderboardTable search={search} tableData={leadeboard} />
      )}
    </div>
  );
};

export default Leaderboard;
